import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { S3Bucket, S3Metrics } from '../../types/s3';

interface S3State {
  selectedBucket: S3Bucket | null;
  buckets: S3Bucket[];
  metrics: Record<string, S3Metrics>;
  isLoading: boolean;
  error: string | null;
}

const initialState: S3State = {
  selectedBucket: null,
  buckets: [],
  metrics: {},
  isLoading: false,
  error: null,
};

const s3Slice = createSlice({
  name: 's3',
  initialState,
  reducers: {
    setSelectedBucket: (state, action: PayloadAction<S3Bucket | null>) => {
      state.selectedBucket = action.payload;
    },
    setBuckets: (state, action: PayloadAction<S3Bucket[]>) => {
      state.buckets = action.payload;
    },
    updateBucketMetrics: (state, action: PayloadAction<{ bucketName: string; metrics: S3Metrics }>) => {
      state.metrics[action.payload.bucketName] = action.payload.metrics;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSelectedBucket, setBuckets, updateBucketMetrics, setLoading, setError } = s3Slice.actions;
export default s3Slice.reducer;